import styled from 'styled-components';
import { Box, spacing } from '@landr/maestro';

// on some device / viewport, a 1px line was visible
// position negatively and add to width and height to prevent this
export const BackgroundOverlayWrapper = styled(Box)`
    position: absolute;
    top: -${spacing('xxs')};
    left: -${spacing('xxs')};
    right: -${spacing('xxs')};
    bottom: -${spacing('xxs')};
    width: calc(100% + ${spacing('xxs')} + ${spacing('xxs')});
    height: calc(100% + ${spacing('xxs')} + ${spacing('xxs')});
`;
